module.exports = __webpack_public_path__ + "img/goblin_shredder_small.afdeca92.png";